import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'
import {COMMON_SEARCH_CONDITION, ADVANCE_SEARCH_CONDITION} from "../../config/localStoreKey";

class Navigation extends Component {
    constructor(props, context) {
        super(props, context);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {

        let searchInfo = this.props.searchInfo;
        let searchCondition = searchInfo.searchCondition;
        // console.log("----searchCondition----", searchCondition)


        return (
            <div className="nav">
                <a href="javascript:" className={COMMON_SEARCH_CONDITION === searchCondition ? "active" : ""}
                   onClick={this.onClick.bind(this)}>图书检索</a>
                <a href="javascript:" className={ADVANCE_SEARCH_CONDITION === searchCondition ? "active" : ""}
                   onClick={this.onClick.bind(this)}>高级检索</a>
            </div>
        )
    }

    // 查询 条件页面 切换
    onClick() {
        let searchInfo = this.props.searchInfo;
        let searchCondition = searchInfo.searchCondition === ADVANCE_SEARCH_CONDITION ? COMMON_SEARCH_CONDITION : ADVANCE_SEARCH_CONDITION;
        this.props.searchInfoActions.searchCondition({
            ...searchInfo, searchCondition: searchCondition
        });
    }

}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/home/Navigation.js